module.exports = __webpack_public_path__ + "37df954bc1a71a1268bcbcb7cb757aff.png";